import React, { useState } from "react";
import { Bar, Line, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";
import { useSelector, useDispatch } from "react-redux";
import {
  setActiveReport,
  setFromDate,
  setToDate,
  setFilter,
  setReportType,
} from "../../../state/reducers/invoiceReportSlice"; // Adjust path as needed

import InvoiceCountReport from "./FullInvoiceChart";
import InvoicePendingCountChart from "./InvoicePendingCountChart";
import PendingDuesChart from "./PendingAmountChart";
import PartialInvoiceCountChart from "./PartialInvoiceCountChart";

// Register Chart.js components
ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
  LineElement,
  Tooltip,
  Legend
);

const InvoiceReport = () => {
  const dispatch = useDispatch();
  const isSideBarOpen = useSelector((state) => state.application.isSideBarOpen);

  const { activeReport, fromDate, toDate, filter, reportType } = useSelector(
    (state) => state.invoiceReport
  );

  const reports = [
    "Pending Amounts",
    "Count of Fully Paid Invoices",
    "Count of Partially Paid Invoices",
    "Count of Unpaid Invoices",
  ];

  // Data for each report
  const reportData = {
    "Pending Amounts": {
      labels: ["Invoice A", "Invoice B", "Invoice C", "Invoice D"],
      datasets: [
        {
          label: "Pending Amount (₹)",
          backgroundColor: ["#f97316", "#facc15", "#34d399", "#60a5fa"],
          data: [200, 150, 300, 100],
        },
      ],
    },
    "Count of Fully Paid Invoices": {
      labels: ["January", "February", "March", "April"],
      datasets: [
        {
          label: "Fully Paid Invoices",
          borderColor: "#34d399",
          backgroundColor: "rgba(52, 211, 153, 0.2)",
          data: [20, 25, 30, 15],
          tension: 0.4,
        },
      ],
    },
    "Count of Partially Paid Invoices": {
      labels: ["January", "February", "March", "April"],
      datasets: [
        {
          label: "Partially Paid Invoices",
          backgroundColor: ["#3b82f6", "#60a5fa", "#1e40af", "#2563eb"],
          data: [10, 12, 15, 9],
        },
      ],
    },
    "Count of Unpaid Invoices": {
      labels: ["January", "February", "March", "April"],
      datasets: [
        {
          label: "Unpaid Invoices",
          backgroundColor: ["#ef4444", "#dc2626", "#991b1b", "#7f1d1d"],
          data: [5, 8, 6, 10],
        },
      ],
    },
  };

  // Render charts based on the active report
  const renderChart = (report) => {
    const data = reportData[report];
    if (report === "Pending Amounts") {
      // Pie chart for Pending Amounts
      // return (
      //   <Pie
      //     data={data}
      //     options={{
      //       responsive: true,
      //       plugins: {
      //         legend: {
      //           display: true,
      //           position: "top",
      //         },
      //       },
      //       layout: {
      //         padding: 20,
      //       },
      //     }}
      //     width={200}
      //     height={200}
      //   />
      // );
      return <PendingDuesChart />;
    } else if (report === "Count of Fully Paid Invoices") {
      // Line chart for Fully Paid Invoices
      // return (
      //   <Line
      //     data={data}
      //     options={{
      //       responsive: true,
      //       plugins: {
      //         legend: {
      //           display: true,
      //         },
      //       },
      //       scales: {
      //         y: {
      //           beginAtZero: true,
      //         },
      //       },
      //     }}
      //     width={600}
      //     height={300}
      //   />
      // );
      return <InvoiceCountReport />;
    } else if (report === "Count of Partially Paid Invoices") {
      // Bar chart for Partially Paid Invoices
      // return (
      //   <Pie
      //     data={data}
      //     options={{
      //       responsive: true,
      //       plugins: {
      //         legend: {
      //           display: true,
      //         },
      //       },
      //       scales: {
      //         y: {
      //           beginAtZero: true,
      //         },
      //       },
      //     }}
      //     width={600}
      //     height={300}
      //   />
      // );
      return <PartialInvoiceCountChart />;
    } else if (report === "Count of Unpaid Invoices") {
      // Pie chart for Unpaid Invoices
      // return (
      //   <Pie
      //     data={data}
      //     options={{
      //       responsive: true,
      //       plugins: {
      //         legend: {
      //           display: true,
      //           position: "top",
      //         },
      //       },
      //       layout: {
      //         padding: 20,
      //       },
      //     }}
      //     width={200}
      //     height={200}
      //   />
      // );
      return <InvoicePendingCountChart />;
    }
  };

  // Sample data to be displayed in List view
  const sampleListData = [
    { invoice: "Invoice A", status: "Pending", amount: 200 },
    { invoice: "Invoice B", status: "Paid", amount: 150 },
    { invoice: "Invoice C", status: "Pending", amount: 300 },
    { invoice: "Invoice D", status: "Paid", amount: 100 },
  ];

  // Function to handle report generation with the provided filters

  // Render the list of data
  const renderList = () => (
    <div className="bg-white p-6 rounded-lg shadow-lg">
      <h3 className="text-xl font-semibold mb-4">Invoice List</h3>
      <table className="min-w-full">
        <thead>
          <tr>
            <th className="px-4 py-2 text-left">Invoice</th>
            <th className="px-4 py-2 text-left">Status</th>
            <th className="px-4 py-2 text-left">Amount (₹)</th>
          </tr>
        </thead>
        <tbody>
          {sampleListData.map((item, index) => (
            <tr key={index}>
              <td className="px-4 py-2">{item.invoice}</td>
              <td className="px-4 py-2">{item.status}</td>
              <td className="px-4 py-2">{item.amount}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <div
      className={`flex-1 bg-white ${
        isSideBarOpen ? "ml-80" : "ml-20"
      } min-h-screen`}
    >
      <div className="flex-1 bg-white min-h-screen p-6 ">
        <h1 className="text-3xl font-bold mb-6">Invoice Report</h1>

        {/* Report Menu */}
        <div className="flex flex-wrap space-x-6 mb-8 ">
          {reports.map((report) => (
            <button
              key={report}
              className={`px-4 py-2 rounded ${
                activeReport === report
                  ? "bg-blue-500 text-white"
                  : "bg-gray-200 text-gray-800"
              }`}
              onClick={() => dispatch(setActiveReport(report))}
            >
              {report}
            </button>
          ))}
        </div>

        {/* Filters and Generate Button */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">{activeReport}</h2>
          {/* <div className="flex flex-wrap items-center space-x-6 mb-8">
            <div>
              <label className="block text-sm font-semibold mb-2">
                From Date
              </label>
              <input
                type="date"
                className="border border-gray-300 rounded px-4 py-2 w-full"
                value={fromDate}
                onChange={(e) => dispatch(setFromDate(e.target.value))}
              />
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2">
                To Date
              </label>
              <input
                type="date"
                className="border border-gray-300 rounded px-4 py-2 w-full"
                value={toDate}
                onChange={(e) => dispatch(setToDate(e.target.value))}
              />
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2">Filter</label>
              <select
                className="border border-gray-300 rounded px-4 py-2 w-full"
                value={filter}
                onChange={(e) => dispatch(setFilter(e.target.value))}
              >
                <option>This filtered period</option>
                <option>All Invoices</option>
                <option>Pending Invoices</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2">
                Report Type
              </label>
              <select
                className="border border-gray-300 rounded px-4 py-2 w-full"
                value={reportType}
                onChange={(e) => dispatch(setReportType(e.target.value))}
              >
                <option>Analytics</option>
                <option>List</option>
              </select>
            </div>
            <div className="flex items-end">
              <button
                onClick={handleGenerate}
                className="bg-blue-500 text-white mt-6 px-4 py-2 rounded"
              >
                Generate
              </button>
            </div>
          </div> */}

          {/* Conditionally render either the chart or the list */}
          <div className="flex justify-center">
            <div className="mb-8  w-2/3 ">
              {reportType === "Analytics"
                ? renderChart(activeReport)
                : renderList()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceReport;

// import React, { useState } from "react";
// import { Bar, Line, Pie } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   BarElement,
//   CategoryScale,
//   LinearScale,
//   ArcElement,
//   LineElement,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { useSelector, useDispatch } from "react-redux";
// import {
//   setActiveReport,
//   setFromDate,
//   setToDate,
//   setFilter,
//   setReportType,
// } from "../../../state/reducers/invoiceReportSlice"; // Adjust path as needed
// import InvoicePartialCountChart from "./InvoicePartialCountChart"; // Import the dynamic chart component

// // Register Chart.js components
// ChartJS.register(
//   BarElement,
//   CategoryScale,
//   LinearScale,
//   ArcElement,
//   LineElement,
//   Tooltip,
//   Legend
// );

// const InvoiceReport = () => {
//   const dispatch = useDispatch();
//   const isSideBarOpen = useSelector((state) => state.application.isSideBarOpen);

//   const { activeReport, fromDate, toDate, filter, reportType } = useSelector(
//     (state) => state.invoiceReport
//   );

//   const reports = [
//     "Pending Amounts",
//     "Count of Fully Paid Invoices",
//     "Count of Partially Paid Invoices",
//     "Count of Unpaid Invoices",
//   ];

//   // Data for each report (excluding Count of Partially Paid Invoices since it uses a separate component)
//   const reportData = {
//     "Pending Amounts": {
//       labels: ["Invoice A", "Invoice B", "Invoice C", "Invoice D"],
//       datasets: [
//         {
//           label: "Pending Amount ($)",
//           backgroundColor: ["#f97316", "#facc15", "#34d399", "#60a5fa"],
//           data: [200, 150, 300, 100],
//         },
//       ],
//     },
//     "Count of Fully Paid Invoices": {
//       labels: ["January", "February", "March", "April"],
//       datasets: [
//         {
//           label: "Fully Paid Invoices",
//           borderColor: "#34d399",
//           backgroundColor: "rgba(52, 211, 153, 0.2)",
//           data: [20, 25, 30, 15],
//           tension: 0.4,
//         },
//       ],
//     },
//     "Count of Unpaid Invoices": {
//       labels: ["January", "February", "March", "April"],
//       datasets: [
//         {
//           label: "Unpaid Invoices",
//           backgroundColor: ["#ef4444", "#dc2626", "#991b1b", "#7f1d1d"],
//           data: [5, 8, 6, 10],
//         },
//       ],
//     },
//   };

//   // Render charts based on the active report
//   const renderChart = (report) => {
//     if (report === "Count of Partially Paid Invoices") {
//       return <InvoicePartialCountChart />; // Render the dynamic component
//     }

//     const data = reportData[report];
//     if (report === "Pending Amounts") {
//       // Pie chart for Pending Amounts
//       return (
//         <Pie
//           data={data}
//           options={{
//             responsive: true,
//             plugins: {
//               legend: {
//                 display: true,
//                 position: "top",
//               },
//             },
//             layout: {
//               padding: 20,
//             },
//           }}
//           width={200}
//           height={200}
//         />
//       );
//     } else if (report === "Count of Fully Paid Invoices") {
//       // Line chart for Fully Paid Invoices
//       return (
//         <Line
//           data={data}
//           options={{
//             responsive: true,
//             plugins: {
//               legend: {
//                 display: true,
//               },
//             },
//             scales: {
//               y: {
//                 beginAtZero: true,
//               },
//             },
//           }}
//           width={600}
//           height={300}
//         />
//       );
//     } else if (report === "Count of Unpaid Invoices") {
//       // Pie chart for Unpaid Invoices
//       return (
//         <Pie
//           data={data}
//           options={{
//             responsive: true,
//             plugins: {
//               legend: {
//                 display: true,
//                 position: "top",
//               },
//             },
//             layout: {
//               padding: 20,
//             },
//           }}
//           width={200}
//           height={200}
//         />
//       );
//     }
//   };

//   // Render the list of data
//   const renderList = () => (
//     <div className="bg-white p-6 rounded-lg shadow-lg">
//       <h3 className="text-xl font-semibold mb-4">Invoice List</h3>
//       <table className="min-w-full">
//         <thead>
//           <tr>
//             <th className="px-4 py-2 text-left">Invoice</th>
//             <th className="px-4 py-2 text-left">Status</th>
//             <th className="px-4 py-2 text-left">Amount ($)</th>
//           </tr>
//         </thead>
//         <tbody>
//           {[
//             { invoice: "Invoice A", status: "Pending", amount: 200 },
//             { invoice: "Invoice B", status: "Paid", amount: 150 },
//             { invoice: "Invoice C", status: "Pending", amount: 300 },
//             { invoice: "Invoice D", status: "Paid", amount: 100 },
//           ].map((item, index) => (
//             <tr key={index}>
//               <td className="px-4 py-2">{item.invoice}</td>
//               <td className="px-4 py-2">{item.status}</td>
//               <td className="px-4 py-2">{item.amount}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );

//   return (
//     <div
//       className={`flex-1 bg-white ${
//         isSideBarOpen ? "ml-80" : "ml-20"
//       } min-h-screen`}
//     >
//       <div className="flex-1 bg-white min-h-screen p-6 ">
//         <h1 className="text-3xl font-bold mb-6">Invoice Report</h1>

//         {/* Report Menu */}
//         <div className="flex flex-wrap space-x-6 mb-8 ">
//           {reports.map((report) => (
//             <button
//               key={report}
//               className={`px-4 py-2 rounded ${
//                 activeReport === report
//                   ? "bg-blue-500 text-white"
//                   : "bg-gray-200 text-gray-800"
//               }`}
//               onClick={() => dispatch(setActiveReport(report))}
//             >
//               {report}
//             </button>
//           ))}
//         </div>

//         {/* Filters and Generate Button */}
//         <div className="mb-8">
//           <h2 className="text-xl font-semibold mb-4">{activeReport}</h2>
//           <div className="flex flex-wrap items-center space-x-6 mb-8">
//             {/* Additional filter fields */}
//           </div>

//           {/* Conditionally render either the chart or the list */}
//           <div className="flex justify-center">
//             <div className="mb-8 w-2/3">
//               {reportType === "Analytics"
//                 ? renderChart(activeReport)
//                 : renderList()}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default InvoiceReport;
